import { merge } from 'lodash';

/* eslint-disable no-unused-vars */

const initialState = {
  show: false,
  apiCallSuccess: false,
  settings: {
    title: 'Loding...',
    component: 'mds-loader',
    data: {},
    size: '600px',
  },
};

const actions = {
  openModal: {
    root: true,
    handler({ commit, state }, payload) {
      commit('updateState', payload);
      commit('openModal');
    },
  },
  closeModal: {
    root: true,
    handler({ commit, state }, payload) {
      commit('resetStateData');
      commit('closeModal');
    },
  },
  closeModalAfterSuccess: {
    root: true,
    handler({ commit, state }, payload) {
      commit('resetStateData');
      commit('closeModalAfterSuccess');
    },
  },
};

const mutations = {
  openModal(state) {
    state.show = true;
  },
  closeModal(state) {
    state.show = false;
  },
  closeModalAfterSuccess(state) {
    state.show = false;
    state.apiCallSuccess = true;
  },
  updateState(state, payload) {
    state.settings = merge(state.settings, payload);
  },
  resetStateData(state, payload) {
    state.settings.data = {};
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
